import AdServeBanner from './AdServeBanner';

export default AdServeBanner;
